import styled from 'styled-components';

export const ContentWrapperContainer = styled.div`
  max-width: 1120px;
  margin: 0 24px;

  @media screen and (min-width: 1168px) {
    margin: 0 auto;
    width: 100%;
  }
`;
